
const _window = window as any;

_window.WorkOrder_yfzb = function (ctrl) {
    // console.log(ctrl);
    if (ctrl.device != "web") return;
    let control1 = getCurrentControl(ctrl.state, "qynzyywsr");
    let control2 = getCurrentControl(ctrl.state, "qynyffy");
    let a = parseFloat(control1.value) || 0;
    let b = parseFloat(control2.value) || 0;
    if (a != 0) {
        let c = 100 * b / a;
        ctrl.setForm("qynydfyzzsrbl", { label: c.toFixed(2), value: c.toFixed(2) });
        $("#render_qynydfyzzsrbl input").val(c.toFixed(2));
    }
};

_window.WorkOrder_yfzb2 = function (ctrl) {
    // console.log(ctrl);
    if (ctrl.device != "web") return;
    let control1 = getCurrentControl(ctrl.state, "qlnzyywsr");
    let control2 = getCurrentControl(ctrl.state, "qlnyffy");
    let a = parseFloat(control1.value) || 0;
    let b = parseFloat(control2.value) || 0;
    if (a != 0) {
        let c = 100 * b / a;
        ctrl.setForm("qlnydfyzzsrbl", { label: c.toFixed(2), value: c.toFixed(2) });
        $("#render_qlnydfyzzsrbl input").val(c.toFixed(2));
    }
};

/**
 * 获取当前Control
 * @param _state
 * @param _controlCode
 * @returns
 */
function getCurrentControl(_state, _controlCode) {
    const controlMap = getControlMap(_state);

    return controlMap[_controlCode];
}

function getControlMap(_state) {
    let controls: any[] = _state?.formData?.controls || [];
    const controlMap: any = {};

    controls.forEach((item) => {
        controlMap[item.controlCode] = item;
    });
    return controlMap;
}
